import { Input, InputNumber, Select, Switch } from "antd";
import bem from "easy-bem";
import React from "react";

import type { ParamValue, ScriptParam } from "../../../../data/types";

import "./ParamField.css";

const cn = bem("param-field");

type Props = {
  param: ScriptParam;
  value: ParamValue;
  onChange: (value: ParamValue) => void;
};

// Поле формы, тип контрола выбирается по типу параметра из схемы argparse.
const ParamField: React.FC<Props> = ({ param, value, onChange }) => {
  const renderControl = () => {
    switch (param.kind) {
      case "bool":
        return (
          <Switch
            checked={Boolean(value)}
            onChange={onChange}
          />
        );
      case "int":
        return (
          <InputNumber
            min={0}
            max={param.max ?? undefined}
            value={typeof value === "number" ? value : null}
            onChange={(next) => onChange(next ?? undefined)}
          />
        );
      case "choice":
        return (
          <Select
            className={cn("select")}
            value={value as string | undefined}
            options={(param.choices ?? []).map((choice) => ({
              value: choice,
              label: choice,
            }))}
            onChange={onChange}
          />
        );
      default:
        return (
          <Input
            value={(value as string | undefined) ?? ""}
            onChange={(event) => onChange(event.target.value)}
          />
        );
    }
  };

  return (
    <div className={cn()}>
      <span className={cn("label")}>{param.flag}</span>
      {renderControl()}
      {param.help && <span className={cn("hint")}>{param.help}</span>}
    </div>
  );
};

export default ParamField;
